import { render, staticRenderFns } from "./BatchFormV2.vue?vue&type=template&id=22b18589&scoped=true&"
import script from "./BatchFormV2.vue?vue&type=script&lang=ts&"
export * from "./BatchFormV2.vue?vue&type=script&lang=ts&"
import style0 from "./BatchFormV2.vue?vue&type=style&index=0&id=22b18589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b18589",
  null
  
)

export default component.exports